import { Injectable } from '@angular/core';
import { RoadbookDownloadInfo } from '../models/roadbookDownloadInfo.model';
import * as firebase from 'firebase';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoadbookDownloadInfoService {

  database = 'UsersApp';
  databaseTrash = 'UsersAppTrash';
  constructor(private afs: AngularFirestore) {
  }

  get ref() {
    return firebase.firestore().collection(this.database);
  }
  create(email: string, info: RoadbookDownloadInfo) {
    info.id = info.orderline_id + '_' + info.roadbook_id;
    return firebase.firestore().doc(this.database + '/' + email + '/roadbooks/' + info.id).set(Object.assign({}, info));
  }
  update(email: string, info: RoadbookDownloadInfo) {
        return firebase.firestore().doc(this.database + '/' + email + '/roadbooks/' + info.id).set(Object.assign({}, info));
  }
  getRoadbooks(email: string) {
    return this.afs.collection<RoadbookDownloadInfo>(this.database + '/' + email + '/roadbooks')
    .snapshotChanges().pipe(map(actions => actions.map(a => {
      return a.payload.doc.data();
    })));
  }
  remove(email: string, roadbook: RoadbookDownloadInfo) {
    this.ref.firestore.doc(this.databaseTrash + '/' + email + '/roadbooks/' + roadbook.id).set(Object.assign({}, roadbook));
    return this.ref.firestore.doc(this.database + '/' + email + '/roadbooks/' + roadbook.id).delete();
  }
}
